import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationStep1 } from "./../../models/classes/ApplicationStep1.class";


export interface ApplicationStep1States {
  formData: ApplicationStep1,
}

const initialState: ApplicationStep1States = {
  formData: new ApplicationStep1(),
};


const ApplicationStep1Slice = createSlice({
  name:"Application Step 1 Slice",
  initialState,
  reducers:{
    updateFormData: (state, action: PayloadAction<ApplicationStep1>) => {
      state.formData = action.payload;
    },
    resetFormData: (state)=>{
      state.formData = new ApplicationStep1();
    }
  },
  extraReducers: (builder)=>{
    builder.addCase(updateApplicationStep1FormDataThunk.fulfilled, (state, action:PayloadAction<ApplicationStep1>) => {
      state.formData = {...state.formData, ...action.payload };
    });
    builder.addCase(updateApplicationStep1FormDataThunk.rejected, (state, action) => {
      state.formData = new ApplicationStep1();
    });
  }
});


export const updateApplicationStep1FormDataThunk = createAsyncThunk(
  "updateApplicationStep1FormDataThunk",
  async (args:any, { fulfillWithValue, rejectWithValue }) => {
    const { data } = args;
    return fulfillWithValue(data);
  }
);


export const { updateFormData, resetFormData } = ApplicationStep1Slice.actions;

export default ApplicationStep1Slice.reducer;